export function InfoSection() {
  return (
    <section id='centerSection'>
      <section id='topText'>
        <h1> I am Aidan.</h1>
        <h2> I make games.</h2>
      </section>
      <p id='mainText'>
        You can learn more about me{' '}
        <a href='https://www.aidanmstrong.com/' id='online-user-label'>
          here.
        </a>
      </p>
    </section>
  );
}
